
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({})
export default class StandardHover extends Vue {
    @Prop({
        required: true,
        type: Boolean,
    })
    overlayVisible!: boolean;

    @Prop({
        required: false,
        type: String,
    })
    photoId?: string;

    @Prop({
        required: true,
        type: Boolean,
    })
    isUploaded!: boolean;

    @Prop({
        required: true,
        type: Boolean,
    })
    recommended!: boolean

    @Prop({
        required: true,
        type: Boolean,
    })
    recommendationInProgress!: boolean;

    @Prop({
        required: false,
        type: Boolean,
        default: false,
    })
    isOrdered!: boolean;

    @Prop({
        required: false,
        type: Boolean,
        default: false,
    })
    finalized!: boolean;

    @Prop({
        required: false,
        type: Boolean,
        default: false,
    })
    finalizationMode!: boolean;

    getIconStyle(finalizationMode: boolean, recommendationInProgress: boolean): string {
        let opacity = 1;
        
        if (finalizationMode) {
            opacity = 0.5;
        } else if (recommendationInProgress) {
            opacity = 0.7;
        }
        
        return `opacity: ${opacity}; cursor: ${recommendationInProgress ? 'wait' : 'pointer'}`;
    }
}

